/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddOrRemoveDocumentToEquipmentDto } from '../models/work-add-or-remove-document-to-equipment-dto';
import { WorkCreateEquipmentDto } from '../models/work-create-equipment-dto';
import { WorkDocument } from '../models/work-document';
import { WorkEquipment } from '../models/work-equipment';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateEquipmentDto } from '../models/work-update-equipment-dto';

@Injectable({ providedIn: 'root' })
export class WorkEquipmentsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `equipmentsV2ControllerFindAllPaginated()` */
  static readonly EquipmentsV2ControllerFindAllPaginatedPath = '/v2/equipments';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Gibt an, ob der neueste EquipmentLog pro Equipment mitgeladen werden soll.
     */
      includeLatestEquipmentLog?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by equipmenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmenttypeId=$not:$like:John Doe&filter.equipmenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmenttypeId'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId=$not:$like:John Doe&filter.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId'?: Array<string>;

    /**
     * Filter by parentId.parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId.parentId=$not:$like:John Doe&filter.parentId.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId.parentId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>equipmenttypeId</li>
     * <li>brand</li>
     * <li>model</li>
     * <li>identifier</li></ul>
     */
      sortBy?: Array<'equipmenttypeId:ASC' | 'equipmenttypeId:DESC' | 'brand:ASC' | 'brand:DESC' | 'model:ASC' | 'model:DESC' | 'identifier:ASC' | 'identifier:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> brand,model,identifier,equipmenttype.name,vendor.company
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>brand</li>
     * <li>model</li>
     * <li>identifier</li>
     * <li>equipmenttype.name</li>
     * <li>vendor.company</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('includeLatestEquipmentLog', params.includeLatestEquipmentLog, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.equipmenttypeId', params['filter.equipmenttypeId'], {});
      rb.query('filter.businessunitId', params['filter.businessunitId'], {});
      rb.query('filter.businessdivisionId', params['filter.businessdivisionId'], {});
      rb.query('filter.parentId', params['filter.parentId'], {});
      rb.query('filter.parentId.parentId', params['filter.parentId.parentId'], {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEquipment>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'equipmenttypeId'?: (string | Array<string>);
        'businessunitId'?: (string | Array<string>);
        'businessdivisionId'?: (string | Array<string>);
        'parentId'?: (string | Array<string>);
        'parentId.parentId'?: (string | Array<string>);
        'userId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Gibt an, ob der neueste EquipmentLog pro Equipment mitgeladen werden soll.
     */
      includeLatestEquipmentLog?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by equipmenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmenttypeId=$not:$like:John Doe&filter.equipmenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmenttypeId'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId=$not:$like:John Doe&filter.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId'?: Array<string>;

    /**
     * Filter by parentId.parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId.parentId=$not:$like:John Doe&filter.parentId.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId.parentId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>equipmenttypeId</li>
     * <li>brand</li>
     * <li>model</li>
     * <li>identifier</li></ul>
     */
      sortBy?: Array<'equipmenttypeId:ASC' | 'equipmenttypeId:DESC' | 'brand:ASC' | 'brand:DESC' | 'model:ASC' | 'model:DESC' | 'identifier:ASC' | 'identifier:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> brand,model,identifier,equipmenttype.name,vendor.company
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>brand</li>
     * <li>model</li>
     * <li>identifier</li>
     * <li>equipmenttype.name</li>
     * <li>vendor.company</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
}> {
    return this.equipmentsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerCreate()` */
  static readonly EquipmentsV2ControllerCreatePath = '/v2/equipments';

  /**
   * Required permissions: equipments:create, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerCreate$Response(
    params: {
      body: WorkCreateEquipmentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipment>;
      })
    );
  }

  /**
   * Required permissions: equipments:create, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerCreate(
    params: {
      body: WorkCreateEquipmentDto
    },
    context?: HttpContext
  ): Observable<WorkEquipment> {
    return this.equipmentsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipment>): WorkEquipment => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerFindAllByUserId()` */
  static readonly EquipmentsV2ControllerFindAllByUserIdPath = '/v2/equipments/byUserId';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerFindAllByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindAllByUserId$Response(
    params?: {
      userId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEquipment>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerFindAllByUserIdPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEquipment>>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerFindAllByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindAllByUserId(
    params?: {
      userId?: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkEquipment>> {
    return this.equipmentsV2ControllerFindAllByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEquipment>>): Array<WorkEquipment> => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerFindAllByUserIdPaginated()` */
  static readonly EquipmentsV2ControllerFindAllByUserIdPaginatedPath = '/v2/equipments/byUserIdPaginated';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerFindAllByUserIdPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindAllByUserIdPaginated$Response(
    params: {
      userId: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by equipmenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmenttypeId=$not:$like:John Doe&filter.equipmenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmenttypeId'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId=$not:$like:John Doe&filter.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId'?: Array<string>;

    /**
     * Filter by parentId.parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId.parentId=$not:$like:John Doe&filter.parentId.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId.parentId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>equipmenttypeId</li>
     * <li>brand</li>
     * <li>model</li>
     * <li>identifier</li></ul>
     */
      sortBy?: Array<'equipmenttypeId:ASC' | 'equipmenttypeId:DESC' | 'brand:ASC' | 'brand:DESC' | 'model:ASC' | 'model:DESC' | 'identifier:ASC' | 'identifier:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> brand,model,identifier,equipmenttype.name,vendor.company
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>brand</li>
     * <li>model</li>
     * <li>identifier</li>
     * <li>equipmenttype.name</li>
     * <li>vendor.company</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerFindAllByUserIdPaginatedPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.equipmenttypeId', params['filter.equipmenttypeId'], {});
      rb.query('filter.businessunitId', params['filter.businessunitId'], {});
      rb.query('filter.businessdivisionId', params['filter.businessdivisionId'], {});
      rb.query('filter.parentId', params['filter.parentId'], {});
      rb.query('filter.parentId.parentId', params['filter.parentId.parentId'], {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEquipment>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'equipmenttypeId'?: (string | Array<string>);
        'businessunitId'?: (string | Array<string>);
        'businessdivisionId'?: (string | Array<string>);
        'parentId'?: (string | Array<string>);
        'parentId.parentId'?: (string | Array<string>);
        'userId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerFindAllByUserIdPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindAllByUserIdPaginated(
    params: {
      userId: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by equipmenttypeId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmenttypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmenttypeId=$not:$like:John Doe&filter.equipmenttypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmenttypeId'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId=$not:$like:John Doe&filter.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId'?: Array<string>;

    /**
     * Filter by parentId.parentId query param.
     *           <p>
     *              <b>Format: </b> filter.parentId.parentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.parentId.parentId=$not:$like:John Doe&filter.parentId.parentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.parentId.parentId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>equipmenttypeId</li>
     * <li>brand</li>
     * <li>model</li>
     * <li>identifier</li></ul>
     */
      sortBy?: Array<'equipmenttypeId:ASC' | 'equipmenttypeId:DESC' | 'brand:ASC' | 'brand:DESC' | 'model:ASC' | 'model:DESC' | 'identifier:ASC' | 'identifier:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> brand,model,identifier,equipmenttype.name,vendor.company
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>brand</li>
     * <li>model</li>
     * <li>identifier</li>
     * <li>equipmenttype.name</li>
     * <li>vendor.company</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
}> {
    return this.equipmentsV2ControllerFindAllByUserIdPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEquipment>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'equipmenttypeId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'parentId'?: (string | Array<string>);
'parentId.parentId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerFindOneById()` */
  static readonly EquipmentsV2ControllerFindOneByIdPath = '/v2/equipments/{id}';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipment>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipment> {
    return this.equipmentsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipment>): WorkEquipment => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerDelete()` */
  static readonly EquipmentsV2ControllerDeletePath = '/v2/equipments/{id}';

  /**
   * Required permissions: equipments:delete, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerDelete$Response(
    params: {
      id: number;
      includingChildren: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('includingChildren', params.includingChildren, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: equipments:delete, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerDelete(
    params: {
      id: number;
      includingChildren: boolean;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.equipmentsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerUpdate()` */
  static readonly EquipmentsV2ControllerUpdatePath = '/v2/equipments/{id}';

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEquipmentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipment>;
      })
    );
  }

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEquipmentDto
    },
    context?: HttpContext
  ): Observable<WorkEquipment> {
    return this.equipmentsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipment>): WorkEquipment => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerFindOneByQrcodeId()` */
  static readonly EquipmentsV2ControllerFindOneByQrcodeIdPath = '/v2/equipments/byQrcodeId/{qrcodeId}';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerFindOneByQrcodeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindOneByQrcodeId$Response(
    params: {
      qrcodeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerFindOneByQrcodeIdPath, 'get');
    if (params) {
      rb.path('qrcodeId', params.qrcodeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipment>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerFindOneByQrcodeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerFindOneByQrcodeId(
    params: {
      qrcodeId: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipment> {
    return this.equipmentsV2ControllerFindOneByQrcodeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipment>): WorkEquipment => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerUnlink()` */
  static readonly EquipmentsV2ControllerUnlinkPath = '/v2/equipments/unlink/{id}';

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerUnlink()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerUnlink$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerUnlinkPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipment>;
      })
    );
  }

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerUnlink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerUnlink(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipment> {
    return this.equipmentsV2ControllerUnlink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipment>): WorkEquipment => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerLink()` */
  static readonly EquipmentsV2ControllerLinkPath = '/v2/equipments/link/{id}/to/{parentId}';

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerLink$Response(
    params: {
      id: number;
      parentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerLinkPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('parentId', params.parentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipment>;
      })
    );
  }

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerLink(
    params: {
      id: number;
      parentId: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipment> {
    return this.equipmentsV2ControllerLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipment>): WorkEquipment => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerGetDocumentsByEquipmentId()` */
  static readonly EquipmentsV2ControllerGetDocumentsByEquipmentIdPath = '/v2/equipments/{id}/documents';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerGetDocumentsByEquipmentId()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerGetDocumentsByEquipmentId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerGetDocumentsByEquipmentIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerGetDocumentsByEquipmentId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentsV2ControllerGetDocumentsByEquipmentId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.equipmentsV2ControllerGetDocumentsByEquipmentId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerAddDocumentToEquipment()` */
  static readonly EquipmentsV2ControllerAddDocumentToEquipmentPath = '/v2/equipments/{id}/documents';

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerAddDocumentToEquipment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerAddDocumentToEquipment$Response(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEquipmentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerAddDocumentToEquipmentPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipment>;
      })
    );
  }

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerAddDocumentToEquipment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerAddDocumentToEquipment(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEquipmentDto
    },
    context?: HttpContext
  ): Observable<WorkEquipment> {
    return this.equipmentsV2ControllerAddDocumentToEquipment$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipment>): WorkEquipment => r.body)
    );
  }

  /** Path part for operation `equipmentsV2ControllerRemoveDocumentFromEquipment()` */
  static readonly EquipmentsV2ControllerRemoveDocumentFromEquipmentPath = '/v2/equipments/{id}/documents/{documentId}';

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentsV2ControllerRemoveDocumentFromEquipment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerRemoveDocumentFromEquipment$Response(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEquipmentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentsV2Service.EquipmentsV2ControllerRemoveDocumentFromEquipmentPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: equipments:update, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentsV2ControllerRemoveDocumentFromEquipment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentsV2ControllerRemoveDocumentFromEquipment(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToEquipmentDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.equipmentsV2ControllerRemoveDocumentFromEquipment$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
